import { Box, Button } from '@material-ui/core';
import React, { FC } from 'react';
import "./index.css"

interface Props {
    applyFilter: () => void;
    checkDiscountFilter: (event: React.ChangeEvent<HTMLInputElement>) => void;
    clearSelectedItem: () => void;
    withDiscount: boolean;
    withoutDiscount: boolean;
    firstCheckboxTitle: string;
    secondCheckboxTitle: string;
}

const DiscountFilter: FC<Props> = ({
    applyFilter,
    checkDiscountFilter,
    clearSelectedItem,
    withDiscount,
    withoutDiscount,
    firstCheckboxTitle,
    secondCheckboxTitle
}) => {
    return (
        <>
            <div className="filter-dropdown">
                <div className="filter-odds-container">
                    <Box>
                        <Box display="flex" alignItems="center">
                            <input type="checkbox" name="with" checked={withDiscount} onChange={checkDiscountFilter} />
                            <div>
                                {firstCheckboxTitle}
                            </div>
                        </Box>
                        <Box display="flex" alignItems="center">
                            <input type="checkbox" name="without" checked={withoutDiscount} onChange={checkDiscountFilter} />
                            <div>
                                {secondCheckboxTitle}
                            </div>
                        </Box>
                        <Box display="flex" justifyContent="space-evenly" alignItems="center" paddingTop="1em">
                            <Button id="apply-button" onClick={applyFilter}>Filter</Button>
                            <Button id="clear-button" onClick={clearSelectedItem}>Clear</Button>
                        </Box>
                    </Box>
                </div>
            </div>
        </>
    )
}

export default DiscountFilter